import React from "react";

export default function Perspective(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path d="M 1.5 1 C 1.222656 1 1 1.222656 1 1.5 L 1 8.5 C 1 8.597656 1.027344 8.691406 1.082031 8.773438 L 3.050781 11.773438 C 3.144531 11.914063 3.300781 12 3.46875 12 L 11.5 12 C 11.777344 12 12 11.777344 12 11.5 L 12 3.5 C 12 3.34375 11.929688 3.199219 11.804688 3.101563 L 9.203125 1.101563 C 9.113281 1.035156 9.007813 1 8.898438 1 Z M 2.707031 2 L 8.726563 2 L 10.03125 3 L 3.707031 3 Z M 2 2.707031 L 3 3.707031 L 3 9.875 L 2 8.351563 Z M 4 4 L 11 4 L 11 11 L 4 11 Z M 13 6 L 13 9 L 15 7.5 Z M 6 13 L 7.5 15 L 9 13 Z"></path>
		</svg>
	);
}
